import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export function MenuSearchBox({ value, onChange }) {
  return (
    <div className="border-b border-slate-200 bg-white/90 px-3 py-2.5 dark:border-white/10 dark:bg-transparent">
      <div className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-2.5 py-2 shadow-sm focus-within:border-morado focus-within:ring-2 focus-within:ring-morado/20 dark:border-white/15 dark:bg-white/5">
        <SearchRoundedIcon className="text-slate-400 dark:text-slate-500" fontSize="small" />
        <input
          type="search"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder="Buscar módulo…"
          aria-label="Buscar módulo en el menú"
          className="w-full bg-transparent text-[12.5px] text-slate-700 placeholder:text-slate-400 focus:outline-none dark:text-slate-100 dark:placeholder:text-slate-500"
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            aria-label="Limpiar búsqueda"
            className="flex h-5 w-5 items-center justify-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-morado dark:hover:bg-white/10"
          >
            <CloseRoundedIcon sx={{ fontSize: 14 }} />
          </button>
        )}
      </div>
    </div>
  );
}
